import { isEmpty } from 'lodash/fp';
import { useQuery } from '@apollo/client';

import { Customer, CustomerMember } from '../../../../selectors/select-customer/types';
import { Service } from '../../../../types/__codegen__/ahm-api/graphql';
import client from '../../../../graphql/client';
import RECOMMENDED_PRODUCTS from '../../queries/fetch-recommended-products/query';

const useGetRecommendedProductsByAgeAndScale = (
  dob: CustomerMember['dob'],
  scale: Customer['scale'],
  selectedServices: { extras: Service['serviceId'][]; hospital: Service['serviceId'][] },
) => {
  const { extras: selectedExtras, hospital: selectedHospital } = selectedServices;

  const { data } = useQuery(RECOMMENDED_PRODUCTS, {
    client,
    variables: { input: { dob, scale } },
  });

  return {
    extras: isEmpty(selectedExtras) ? (data?.recommendProducts?.extras as string) : null,
    hospital: isEmpty(selectedHospital) ? (data?.recommendProducts?.hospital as string) : null,
  };
};

export default useGetRecommendedProductsByAgeAndScale;
